import { reducer as customers } from 'logic/customers'
import { reducer as dates } from 'logic/dates'
import { reducer as events } from 'logic/events'
import { reducer as locations } from 'logic/locations'
import { reducer as orders } from 'logic/orders'
import { reducer as orgs } from 'logic/orgs'
import { reducer as payment } from 'logic/payment'
import { reducer as pcts } from 'logic/pcts'
import { reducer as seats } from 'logic/seats'
import { reducer as sweetalert } from 'logic/sweetalert'
import { reducer as spl } from 'logic/spl'
import { reducer as vouchers } from 'logic/vouchers'
import { reducer as goods } from 'logic/goods'
import { intlReducer as intl } from 'react-intl-redux'
import { combineReducers } from 'redux'

export default combineReducers({
  customers,
  dates,
  events,
  goods,
  intl,
  locations,
  orders,
  orgs,
  payment,
  pcts,
  seats,
  sweetalert,
  spl,
  vouchers,
})
